import { Grid, Pagination, SxProps, Theme, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useCouponShares from '../couponShares/useCouponShares';
import CouponsTable from './couponstable';
import terminalBg from '../images/dbet_terminal_background.png';

export default function TerminalCouponAgent({ agentId }: { agentId: number }) {

  const [pageActive, setPageActive] = useState(0);
  const [couponSharesResponseActive, couponSharesQuery] = useCouponShares(true, false, pageActive, 10, "offline", agentId);

  const { t } = useTranslation();

  if (couponSharesResponseActive === undefined) {
    return <></>
  }

  const activeCoupons = couponSharesResponseActive.couponShares;


  var wrapperStyle: SxProps<Theme> = {
    paddingBottom: "120px",
    backgroundImage: `url(${terminalBg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'top center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'transparent',
    overflow: "hidden",
    padding: "40px",
    width: "100%",
    minHeight: "100vh"
  }

  let contentStyle: SxProps<Theme> = {
    marginTop: "20px",
    width: "100%",
  }

  let paginationStyle: SxProps<Theme> = {
    marginTop: "20px",
    "& .MuiPaginationItem-root": {
      color: "var(--pagination-text)",
      backgroundColor: "var(--pagination-background)"
    }
    ,
    "& button[aria-current=true]": {
      color: "var(--pagination-selected-text)",
      backgroundColor: "var(--pagination-selected-background)"
    },
  }

  return (
    <>
      <Grid container direction="column" alignItems="center" sx={wrapperStyle}>

        <Grid sx={contentStyle}>
          {/* Header and Filter Row */}
          <Grid container direction="row" alignItems="center" justifyContent="space-between" sx={{
            width: "100%",
            marginBottom: "40px",
            paddingRight: "40px",
            flexShrink: 0,
            flexWrap: "nowrap"
          }}>
            <Grid item sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>

              <Typography sx={{
                fontSize: "46px",
                fontWeight: "700",
                color: "#091F51",
                fontFamily: 'Roboto',
                textTransform: "uppercase",
                fontStyle: "italic",
              }}>
                {t('unsettled_coupons')}
              </Typography>
            </Grid>

          </Grid>

          <Grid sx={{ marginTop: "18px" }}>
            {activeCoupons !== undefined && activeCoupons.length > 0 ? (
              <CouponsTable coupons={activeCoupons} onCouponCancelled={() => couponSharesQuery.reloadCouponShares()} />
            ) : (
              <Typography sx={{ color: "var(--text-black-dark-background)" }}>{t('no_coupons')}</Typography>
            )}
          </Grid>
          <Grid container justifyContent="center">
            <Pagination sx={paginationStyle} count={couponSharesResponseActive?.totalPages} onChange={(e, page) => setPageActive(page - 1)} />
          </Grid>
        </Grid>

      </Grid >
    </>
  )
}

